import React from 'react';
export function ArrowLeftRightIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.707 12.294a1 1 0 00-1.414 1.414L17.585 15H4a1 1 0 100 2h13.587l-1.294 1.294a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414l-3-3zM6.293 11.707a1 1 0 101.414-1.414L6.414 9H20a1 1 0 100-2H6.414l1.293-1.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3z"
  }));
}